export const Icon_1 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="16px" height="35px" viewBox="0 0 16 35" version="1.1">
      <title>Fill 1</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-49.000000, -54.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <path
                d="M84.8181818,12.7218466 C84.8181818,12.7218466 80.2363636,26.1147383 87,38 C87,38 76.5272727,32.8145644 73.9090909,25.8983968 C73.9090909,25.9051574 67.3636364,17.4745992 73.9090909,3 L84.8181818,12.7218466 Z"
                id="Fill-1"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_2 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="29px" height="17px" viewBox="0 0 29 17" version="1.1">
      <title>Fill 5</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-74.000000, -162.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <path
                d="M96,121.384387 C96,121.384387 106.356196,127.050994 110.082305,127.999821 C110.082305,127.999821 116.559899,128.190904 125,116.099948 L114.398491,111 C114.405121,110.993413 106.846822,126.675416 96,121.384387 Z"
                id="Fill-5"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_3 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="20px" height="40px" viewBox="0 0 20 40" version="1.1">
      <title>Fill 7 2</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-233.000000, -224.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37-Copy" transform="translate(224.844667, 0.000000)">
              <path
                d="M30.2662438,187.053678 C30.2662438,187.053678 40.4242488,184.859011 44.9374119,175 C44.9374119,175 38.4387282,197.463054 50.1553331,204.040258 L37.0427648,215 C37.0359883,214.993205 29.1345647,209.516732 30.2662438,187.053678 Z"
                id="Fill-7"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_4 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="18px" height="19px" viewBox="0 0 18 19" version="1.1">
      <title>Fill 11 2</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-342.000000, -118.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37-Copy" transform="translate(224.844667, 0.000000)">
              <polygon
                id="Fill-11"
                points="139.155333 69 157.155333 72.2575275 144.063233 88"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_5 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="24px" height="23px" viewBox="0 0 24 23" version="1.1">
      <title>Fill 13</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-356.000000, -167.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <polygon
                id="Fill-13"
                points="399.871723 136.53595 391.780257 134.045546 385.040714 139 385.020636 130.889716 378 126.310799 386.084774 123.780865 388.480759 116 393.500279 122.54884 402 122.324835 397.020636 128.89344"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_6 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="17px" height="36px" viewBox="0 0 17 36" version="1.1">
      <title>Fill 29</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-140.000000, -51.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <path
                d="M166.581764,36 L172.424861,32.2129957 C172.424861,32.2129957 165.102668,23.0504562 169.006949,20.1280953 C172.91123,17.2057345 174.876696,19.7259356 178.081404,13.3785142 C181.286113,7.03109291 175.076574,0 175.076574,0 L168.627181,1.75609756 C168.627181,1.75609756 174.676818,6.69595978 171.698638,10.8516105 C168.720457,15.0072612 165.309208,12.9026252 162.857373,18.2513498 C160.4122,23.5933718 163.683535,31.6968907 166.581764,36 Z"
                id="Fill-29"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_7 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1">
      <title>Star</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-166.000000, -134.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <polygon
                id="Star"
                points="204.5 104.095354 200.828405 115.586311 202.50615 103.640271 194.212418 112.400219 200.907207 102.365157 189.634014 106.659082 200.019861 100.522563 188 99.5 200.019861 98.4774375 189.634014 92.3409183 200.907207 96.6348434 194.212418 86.5997805 202.50615 95.3597288 200.828405 83.4136894 204.5 94.9046456 208.171595 83.4136894 206.49385 95.3597288 214.787582 86.5997805 208.092793 96.6348434 219.365986 92.3409183 208.980139 98.4774375 221 99.5 208.980139 100.522563 219.365986 106.659082 208.092793 102.365157 214.787582 112.400219 206.49385 103.640271 208.171595 115.586311"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_8 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="22px" height="21px" viewBox="0 0 22 21" version="1.1">
      <title>Star 2</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-235.000000, -90.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37-Copy" transform="translate(224.844667, 0.000000)">
              <polygon
                id="Star"
                points="43.1553331 58.2184477 38.382612 61.9106575 38.2935549 55.8771387 32.4311261 54.4477303 37.0927948 50.6162652 34.5551868 45.1416122 40.4572497 46.3973722 43.1553331 41 45.8534164 46.3973722 51.7554794 45.1416122 49.2178714 50.6162652 53.8795401 54.4477303 48.0171113 55.8771387 47.9280542 61.9106575"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Icon_9 = ({ fill = "#FEF6E1" }) => {
  return (
    <svg width="29px" height="35px" viewBox="0 0 29 35" version="1.1">
      <title>Fill 35</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Loyalty-tab---Terms-and-conditions"
          transform="translate(-41.000000, -188.000000)"
          fill={fill}
        >
          <g id="artwork" transform="translate(-22.000000, 49.000000)">
            <g id="Group-37" transform="translate(0.000000, 2.000000)">
              <path
                d="M76.4262556,167.697146 C75.9366008,167.08347 75.5557581,166.436442 75.2701261,165.782743 C73.6991502,162.147379 74.9640919,157.965043 78.2828636,155.830518 C80.12587,154.643188 81.152785,152.648741 80.6631302,151.194595 C80.0918662,149.533667 77.3715615,148.573131 73.3591121,148.653176 C68.3265484,148.766572 65.0417805,147.53255 63.6748274,145.064504 C61.7026065,141.535867 64.6473363,137.446916 64.9873744,137 L69.0950345,139.788224 L67.0412044,138.394112 L69.1018352,139.781554 C68.4625636,140.642034 67.796089,142.216247 68.1361271,142.823253 C68.4421613,143.156772 69.707103,143.937208 73.2366984,143.857163 C82.4313282,143.657052 84.8660009,147.899421 85.4712687,149.733779 C86.6546013,153.255746 84.8592002,157.39806 81.1051797,159.812742 C79.7586289,160.673223 79.268974,162.420865 79.9354487,163.955056 C80.8807546,166.142944 84.3015377,168.044006 91.0614949,166.829995 L92,171.545962 C83.8798905,173.000108 78.8609283,170.758856 76.4262556,167.697146 Z"
                id="Fill-35"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
